import { FC } from "react";
import {
  Box,
  Container,
  Flex,
  Heading,
  Image,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import { AboutSection as AboutSectionType } from "../../Landing/config/landing.config";

interface AboutSectionProps {
  config: AboutSectionType;
}

export const AboutSection: FC<AboutSectionProps> = ({ config }) => {
  return (
    <Box margin={{ base: 6, md: 16, lg: 24 }}>
      <Container maxW="100%" padding="0">
        <Flex
          direction={{ base: "column", lg: "row" }}
          gap={{ base: 8, lg: 16 }}
          align="center"
          justify="center"
        >
          <Box
            flex="1"
            maxW={{ base: "100%", lg: "533px" }}
            height={{ base: "auto", lg: "694px" }}
          >
            <Image
              src={config.image.src}
              alt={config.image.alt}
              width="100%"
              height="100%"
              objectFit="cover"
              borderRadius="lg"
            />
          </Box>
          <Box flex="1">
            <Heading as="h2" fontSize={{ base: "3xl", lg: "4xl" }} mb={8}>
              {config.title}
            </Heading>
            <Text color="gray.600" mb={8}>
              {config.description}
            </Text>
            <Accordion allowToggle>
              {config.accordionItems.map((item, index) => (
                <AccordionItem key={index} border="none" borderRadius="0">
                  <AccordionButton backgroundColor="gray.100">
                    <Box flex="1" textAlign="left" fontWeight="bold">
                      {item.title}
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel py={5} px={3}>
                    {item.content}
                  </AccordionPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};
